var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRepoInternal = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 16,
  viewBox: "0 0 16 16",
  width: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1 2.5c0-.66304.26339-1.29893.73223-1.767767.46884-.468841 1.10473-.732233 1.76777-.732233h8.75c.1989 0 .3897.0790176.5303.21967.1407.140652.2197.331418.2197.53033v3.5c0 .19891-.079.38968-.2197.53033-.1406.14065-.3314.21967-.5303.21967s-.3897-.07902-.5303-.21967c-.1407-.14065-.2197-.33142-.2197-.53033v-2.75h-8c-.26522 0-.51957.10536-.70711.29289-.18753.18754-.29289.44189-.29289.70711v6.708c.3154-.13763.65588-.20845 1-.208h2.75c.19891 0 .38968.07902.53033.21967s.21967.33142.21967.53033-.07902.3897-.21967.5303c-.14065.1407-.33142.2197-.53033.2197h-2.75c-.26522 0-.51957.1054-.70711.2929-.18753.1875-.29289.4419-.29289.7071s.10536.5196.29289.7071c.18754.1875.44189.2929.70711.2929h2.75c.19891 0 .38968.079.53033.2197.14065.1406.21967.3314.21967.5303s-.07902.3897-.21967.5303c-.14065.1407-.33142.2197-.53033.2197h-2.75c-.66304 0-1.29893-.2634-1.76777-.7322-.46884-.4689-.73223-1.1048-.73223-1.7678z"
}), /*#__PURE__*/React.createElement("rect", {
  height: 2,
  rx: 1,
  width: 8,
  x: 8,
  y: 14
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 6.5-3.25 2h6.5z",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  height: 5,
  rx: 0.75,
  width: 1.5,
  x: 8.5,
  y: 10
}), /*#__PURE__*/React.createElement("rect", {
  height: 5,
  rx: 0.75,
  width: 1.5,
  x: 11.25,
  y: 10
}), /*#__PURE__*/React.createElement("rect", {
  height: 5,
  rx: 0.75,
  width: 1.5,
  x: 14,
  y: 10
}))));
export default SvgRepoInternal;